import React, { useEffect } from "react";
import { Alert } from "react-bootstrap";

const AlertMessages = ({ alerts, setAlerts }) => {
  useEffect(() => {
    if (alerts.length > 0) {
      const timer = setTimeout(() => {
        setAlerts([]);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [alerts, setAlerts]);

  return alerts.map((alert, index) => (
    <Alert key={index} variant={alert.variant} className="mb-0 p-3 d-flex gap-2 align-content-center">
      {alert.variant === "success" && <i class="bi bi-check-circle fs-16"></i>}
      {(alert.variant === "danger" || alert.variant === "warning") && <i class="bi bi-exclamation-triangle fs-16"></i>}
      {alert.variant === "primary" && <i class="bi bi-info fs-16 "></i>}
      <h6 className="mb-0">{alert.heading}</h6>
    </Alert>
  ));
};

export default AlertMessages;
